import { render, staticRenderFns } from "./bom-management.vue?vue&type=template&id=e68e7bfa&"
import script from "./bom-management.vue?vue&type=script&lang=js&"
export * from "./bom-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MarketingPage1: require('/opt/build/repo/components/elements/MarketingPage1.vue').default})
